var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainImgVideoAutoPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 805.3 525.6",
    style: {
      enableBackground: "new 0 0 805.3 525.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#7E7E86;}\n\t.st3{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:bevel;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_209",
    transform: "translate(1 1.013)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_46",
    transform: "matrix(0.9977 -6.787599e-02 6.787599e-02 0.9977 -32.7171 28.2919)",
    className: "st0",
    cx: 400,
    cy: 495.6,
    rx: 112.7,
    ry: 20.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_151",
    transform: "translate(-5422.684 -4254.259)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5448.2,4769.1v-445.5l773.4-53.9v445.5L5448.2,4769.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5449.2,4768l771.4-53.7v-443.5l-771.4,53.7V4768 M5454,4770.2l-6.8-447.5l775.4-54v447.5L5454,4770.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_152",
    transform: "translate(-5417.702 -4250.698)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5483.2,4737v-394.6l693.6-47.7v394.6L5483.2,4737z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5484.2,4735.9l691.6-47.6v-392.6l-691.6,47.6V4735.9 M5482.2,4738.1v-396.6l695.6-47.9v396.6L5482.2,4738.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_153",
    className: "st3",
    d: "M800,16.7L759.5,0L0,48.3v445.1l31.4,22.5V70.4L800,16.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImgVideoAutoPlay);
export default __webpack_public_path__ + "static/media/main_img_video_auto_play.00d1100ec349ff3fed930db1c4014be9.svg";
export { ForwardRef as ReactComponent };